import React, { useEffect, useState } from 'react';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { Col, Row, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { LocationTable } from '@app/components/apps/Locations/LocationTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const AllLocations: React.FC = () => {
  const { t } = useTranslation();
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate('/add-location');
  };

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/locations',
            breadcrumbName: 'Locations',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'create_location',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons]);

  return (
    <>
      <PageTitle>{'Locations'}</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <LocationTable />
        </Col>
      </Row>
    </>
  );
};

export default AllLocations;
